// @ts-nocheck
import { useState, useMemo } from "react";
import {
  Box,
  VStack,
  Text,
  Divider,
} from "@chakra-ui/react";
import { Drawer } from "barte-design-system";
import { formatCurrency, showToast, getPaymentErrorMessages } from "@/utils";
import { usePayment } from "@/hooks/usePayment";

interface BankSlipCancelDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  payment: any;
  onAfterCancel?: () => void;
}

const BankSlipCancelDrawer = ({ isOpen, onClose, payment, onAfterCancel }: BankSlipCancelDrawerProps) => {
  const [isCancelling, setIsCancelling] = useState(false);
  const { getListPaymentsInitialData, cancelPayment } = usePayment();
  const summaryText = useMemo(() => {
    if (!payment) return "";
    const amountText = formatCurrency({ value: parseFloat(payment.amount) });
    const beneficiary = payment.recipientName || payment.beneficiary || "—";
    return (
      <>
        {" Você estava pagando "}
        <strong>{amountText}</strong>
        {" para "}
        <strong>{beneficiary}</strong>
      </>
    );
  }, [payment]);

  const handleConfirmCancel = async () => {
    if (!payment) return;
    if (!payment.transferId) {
      return;
    }
    try {
      setIsCancelling(true);
      await cancelPayment(payment.transferId);
      try {
        getListPaymentsInitialData();
      } catch (_) { 
      }
      onClose?.();
      if (onAfterCancel) onAfterCancel();
    } catch (error: any) {
      const errorMessages = getPaymentErrorMessages(error);
      errorMessages.forEach((errorMapping) => {
        showToast({
          type: "error",
          message: errorMapping.message,
          title: errorMapping.title,
        });
      });
    } finally {
      setIsCancelling(false);
    }
  };

  return (
    <Drawer
      title="Cancelar agendamento"
      isOpen={isOpen}
      onClose={onClose}
      footer={{
        secondaryButton: { children: "Voltar", variant: "outline", onClick: onClose },
        primaryButton: {
          children: "Cancelar agendamento",
          className: "!bg-[#C68A31] hover:!bg-[#C68A31] !text-white",
          loading: isCancelling,
          onClick: handleConfirmCancel,
        },
      }}
    >
      <VStack spacing={6} align="stretch" flex="1">
        <Box px={0} mb={10} p={6}>
          <VStack spacing={2} align="stretch" mt={250} p={0}>
            <Text fontSize="20px" fontWeight="600" color="gray.900" p={0} mt={0}>
              Tem certeza que deseja cancelar esse agendamento?
            </Text>
            <Text fontSize="16px" color="gray.500" pb={6} mt={2}>Essa operação não poderá ser desfeita</Text>
          </VStack>
          <Divider my={6} p={0} mt={0} />
          <Text fontSize="16px" color="gray.700" p={0} mt={0}>{summaryText}</Text>
        </Box>
      </VStack>
    </Drawer>
  );
};

export default BankSlipCancelDrawer;